import React, { ReactElement } from 'react';
import { Button, Tooltip, Typography } from '@mui/material';
import { DataDueDiligence } from '../../../types/types';
import CustomTable, { Column } from "../../table/table";
import EntityLink from "../../modularcomponents/entitylink/entitylink";
import { FilterParamsManager } from "../../entity/list";
import { DdPublishService } from '../../../services/ddpublish';

export function DdsPublishTable(props: {list: Array<DataDueDiligence>, paramsSort?: FilterParamsManager, singleReviewCol?: boolean}) : ReactElement {
  const ddPublishService = new DdPublishService();

  const performPublish = (ddId: string) => ddPublishService.performPublish(ddId);
  const cancelPublish = (ddId: string) => ddPublishService.cancelPublish(ddId);

  const columns: Array<Column> = [
    { id: 'name', label: 'Name', minWidth: 'min-content' },
    { id: 'validationDate', label: 'Validation Date', minWidth: 'min-content' },
    { id: 'publishStatus', label: 'Publish Status', minWidth: 'min-content', align: 'center' },
    { id: 'startTime', label: 'Start Time', minWidth: 'min-content', align: 'center' },
    { id: 'endTime', label: 'End Time', minWidth: 'min-content', align: 'center' },
    { id: 'performPublish', label: '', minWidth: 'min-content', align: 'center' },
    { id: 'cancelPublish', label: '', minWidth: 'min-content', align: 'center' }
  ];

  const sortByValidationDateDescOrder = (a: DataDueDiligence, b: DataDueDiligence) => {
    if (!a.validationDate && !b.validationDate) return 0;
    if (!a.validationDate) return 1;
    if (!b.validationDate) return -1;

    const dateA = new Date(a.validationDate);
    const dateB = new Date(b.validationDate);

    if (Number.isNaN(dateA.getTime()) && Number.isNaN(dateB.getTime())) return 0;
    if (Number.isNaN(dateA.getTime())) return 1;
    if (Number.isNaN(dateB.getTime())) return -1;

    return dateB.getTime() - dateA.getTime();
  };

  const rows = props.list
    .sort(sortByValidationDateDescOrder)
    .map((dd: DataDueDiligence) => ({
      id: dd._id,
      value: columns.map(column => (
        <>
          {column.id === 'name' &&
              <Typography>
                <EntityLink type='dueDiligence' id={`${dd._id}`} name={dd.auditedEntity.name} center={column.align === 'center'} openInNewTabIcon />
              </Typography>
          }
          {column.id === 'validationDate' &&
              <Typography>
                {dd.validationDate}
              </Typography>
          }
          {column.id === 'publishStatus' &&
            <Tooltip title={dd?.publishInfo?.errorMsg || undefined}>
              <Typography>
                {dd?.publishInfo?.status}
              </Typography>
            </Tooltip>
          }
          {column.id === 'startTime' &&
            <Typography>
              {dd?.publishInfo?.startTime}
            </Typography>
          }
          {column.id === 'endTime' &&
            <Typography>
              {dd?.publishInfo?.endTime}
            </Typography>
          }
          {column.id === 'performPublish' &&
          <Button
            size='small'
            variant='outlined'
            color='primary'
            onClick={() => {
              performPublish(dd._id);
              window.location.reload();
            }}
            sx={{
              minWidth: '135px',
              maxWidth: '200px',
              maxHeight: '50px'
            }}>
              Publish
          </Button>
          }
          {column.id === 'cancelPublish' &&
          <Button
            size='small'
            variant='outlined'
            color='primary'
            onClick={() => {
              cancelPublish(dd._id);
              window.location.reload();
            }}
            sx={{
              minWidth: '160px',
              maxWidth: '200px',
              maxHeight: '50px'
            }}>
              Cancel Publish
          </Button>
          }
        </>
      ))
    }));

  return (
    <CustomTable columns={columns} rows={rows} size='medium' paramsSort={props.paramsSort} />
  );
}

export default DdsPublishTable;
